export const GET_TOWNS = "GET_TOWNS";
export const GET_TOWNS_SUCCESS = "GET_TOWNS_SUCCESS";
export const GET_TOWNS_FAILURE = "GET_TOWNS_FAILURE";
